import { forwardRef, HTMLAttributes, useCallback, useEffect, useState } from 'react';

import { AccordionProvider } from './context';

export interface AccordionProps extends HTMLAttributes<HTMLDivElement> {
  defaultExpanded?: boolean;
}

const Accordion = forwardRef<HTMLDivElement, AccordionProps>(({ defaultExpanded = false, ...rest }, ref) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  useEffect(() => setIsExpanded(defaultExpanded), [defaultExpanded]);

  const handleClickAccordion = useCallback(() => {
    setIsExpanded((prevIsExpanded) => !prevIsExpanded);
  }, []);

  return (
    <AccordionProvider value={{ isExpanded, onClick: handleClickAccordion }}>
      <div ref={ref} {...rest} />
    </AccordionProvider>
  );
});

export default Accordion;
